import { Link, useParams } from "react-router-dom";
import { accountText } from "./_accountText";

export default function Login(){
  const{lang="en"}=useParams();
  const copy = accountText(lang);
  return <section className="container-page py-10"><form className="panel mx-auto max-w-md space-y-4 p-6"><h1 className="text-2xl font-black">{copy.loginTitle}</h1><input className="input" placeholder={copy.email}/><input className="input" type="password" placeholder={copy.password}/><Link className="btn-primary w-full" to={`/${lang}/account`}>{copy.login}</Link></form></section>;
}
